/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.components

import japgolly.scalajs.react._
import japgolly.scalajs.react.extra.router.RouterCtl
import japgolly.scalajs.react.vdom.html_<^._
import net.scalytica.blaargh.CssSettings._
import net.scalytica.blaargh.models.Article
import net.scalytica.blaargh.pages.Views.{Posts, View}
import net.scalytica.blaargh.styles.BlaarghBootstrapCSS
import net.scalytica.blaargh.utils.StringUtils._
import scalacss.ScalaCssReact._

object ArticleCard {

  case class Props(article: Article, ctl: RouterCtl[View])

  object Styles extends StyleSheet.Inline {

    import dsl._

    val articleCard = style("blaargh-article-card")(
      BlaarghBootstrapCSS.card,
      marginRight(0.75 rem),
      marginTop(0.75 rem),
      transitionProperty := "box-shadow",
      BlaarghBootstrapCSS.Mixins.easeInOutAnimation,
      &.hover(
        BlaarghBootstrapCSS.Mixins.cardShadow
      )
    )

    val cardTitle = style("blaargh-article-card-title")(
      addClassName("card-title"),
      color black,
      cursor pointer,
      &.hover(
        textDecoration := "none"
      )
    )

    val cardMixin = mixin(
      width(100 %%),
      cursor pointer
    )

    val cardImage = style("blaargh-article-card-image")(
      addClassName("card-img"),
      cardMixin
    )

    val cardImageTop = style("blaargh-article-card-image-top")(
      addClassName("card-img-top"),
      cardMixin
    )

    val cardImageBottom = style("blaargh-article-card-image-bottom")(
      addClassName("card-img-bottom"),
      cardMixin
    )

  }

  class Backend($ : BackendScope[Props, Unit]) {

    def maybeTitle(props: Props)(content: TagMod => TagMod): TagMod =
      asOption(props.article.title).map { title =>
        content(
          <.a(
            Styles.cardTitle,
            ^.key := "art-card-1-link",
            <.h4(^.onClick --> openArticleCB(props), title)
          )
        )
      }.getOrElse(EmptyVdom)

    def maybeImage(props: Props) = asOption(props.article.image).map { image =>
      <.img(
        Styles.cardImage,
        ^.key := "art-card-1-img",
        ^.src := image,
        ^.onClick --> openArticleCB(props)
      )
    }

    def openArticleCB(props: Props): Callback =
      props.ctl.byPath.set(Posts(props.article.articleRef).asPath)

    def render(props: Props) =
      <.div(^.key := "art-card-1",
        Styles.articleCard,
        maybeImage(props).getOrElse(EmptyVdom),
        maybeTitle(props) { title =>
          <.div(^.key := "art-card-1-1",
            BlaarghBootstrapCSS.cardBlock,
            title,
            <.p(BlaarghBootstrapCSS.cardText, props.article.ingress)
          )
        }
      )

  }

  val component = ScalaComponent
    .builder[Props]("ArticleCard")
    .stateless
    .renderBackend[Backend]
    .build

  def apply(article: Article, ctl: RouterCtl[View]) =
    component(Props(article, ctl))

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/components/ArticleCard.scala